<section class="cms-full-width-booking-widget relative">
  <fin-content-image
    class="background-image"
    [imageData$]="backgroundImage | finToObservable"
    [aspectRatio$]="aspectRatio$"
  ></fin-content-image>
  <div class="grid-max-width grid-col-12 bg-container">
    <div class="col-1-12 mr-xlarge-y">
      <fin-booking-widget
        *ngIf="!isNewWidget"
        class="center"
        [embedded]="true"
        [shouldRenderMainHeading]="false"
        [enableCompactWidget]="true"
        [enablePersistence]="false"
        [enablePromoCode]="enablePromoCode"
        [enableAward]="enableAward"
        [enableAurinkomatkat]="enableAurinkomatkat"
        [locations$]="locations | finToObservable"
        [enableAutoFocus]="enableAutoFocus"
        [shouldExpandWidget]="locations?.[0]?.destinationLocationCode ? true : false"
        [enableOpenJaw]="enableOpenJaw"
        [contentType]="contentType"
      >
      </fin-booking-widget>
      <fin-booking-widget-v2
        *ngIf="isNewWidget"
        [compactMode]="true"
        [enableAurinkomatkat]="enableAurinkomatkat"
        [defaultLocations$]="defaultLocationPairs | finToObservable"
      >
      </fin-booking-widget-v2>
    </div>
  </div>
</section>
